import type { ReactNode } from "react"
import type { NostrEvent } from "@/nostr/types"
import { InfiniteScroll } from "./InfiniteScroll"
import { NoteCard } from "./NoteCard"
import { EmptyState, Skeleton } from "./Feedback"

export interface NoteListProps {
  events: NostrEvent[]
  loading: boolean
  loadingMore?: boolean
  hasMore?: boolean
  onLoadMore?: () => void
  emptyTitle?: string
  emptyDescription?: ReactNode
  emptyAction?: ReactNode
  emptyIcon?: string
  onHashtagClick?: (tag: string) => void
  className?: string
}

/** Shared note list: skeletons, empty state and incremental loading. */
export function NoteList({
  events,
  loading,
  loadingMore = false,
  hasMore = false,
  onLoadMore,
  emptyTitle = "No notes yet",
  emptyDescription,
  emptyAction,
  emptyIcon,
  onHashtagClick,
  className = "",
}: NoteListProps) {
  if (loading && events.length === 0) {
    return (
      <div className={`note-list ${className}`} aria-busy="true">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} />
        ))}
      </div>
    )
  }

  if (events.length === 0) {
    return (
      <EmptyState icon={emptyIcon} title={emptyTitle} description={emptyDescription} action={emptyAction} />
    )
  }

  return (
    <div className={`note-list ${className}`}>
      {events.map((event) => (
        <NoteCard key={event.id} event={event} onHashtagClick={onHashtagClick} />
      ))}
      {hasMore && onLoadMore && (
        <InfiniteScroll onLoadMore={onLoadMore} disabled={loadingMore} loading={loadingMore} />
      )}
      {!hasMore && events.length > 0 && <p className="list-end">You reached the end of this relay feed.</p>}
    </div>
  )
}
